module.exports = __webpack_public_path__ + "img/homeBg.5d9cc555.png";